module.exports = __webpack_public_path__ + "static/media/pr.3d6afa72.svg";